import { PolymerElement, html } from '@polymer/polymer';
import '@polymer/polymer/lib/elements/dom-if.js';
import '@polymer/polymer/lib/elements/dom-repeat.js';
import '@wdpr/typography';
import '@wdpr/color';
import '@wdpr/mdx-icons';

import './style/wdpr-single-select-style.js';

class WdprSingleSelect extends PolymerElement {

  static get is() {
    return 'wdpr-single-select';
  }

  static get template() {
    return html`
      <!-- Scoped styles for this element -->
      <style include="wdpr-typography"></style>
      <style include="wdpr-color"></style>
      <style include="wdpr-mdx-icons"></style>
      <style include="wdpr-single-select-style"></style>

      <!-- Native dropdown -->
      <div class\$="native-dropdown-container [[computeInvalidClass(invalid)]] [[computeDisabledClass(disabled)]]"
           hidden\$="[[!computeUseNativeOptionsMenu()]]">

          <!-- Floating label -->
          <div id="native-dropdown-label"
              class\$="label [[computeLabelVisibility(value)]]"
              aria-hidden="true">
              {{ label }}
          </div>

          <div class="select-and-icon-container">
              <select id="native-dropdown"
                      class\$="native-select [[computeItemSelectedClass(value)]]"
                      on-change="selectNativeOption"
                      disabled\$="{{disabled}}"
                      aria-required\$="{{requiredField}}"
                      aria-label\$="[[computeAriaLabel(customAriaLabel, label, placeholder)]]"
                      aria-describedby\$="[[computeCustomButtonErrorAriaDescribedby(customButtonErrorAriaDescribedby)]]"
                      aria-invalid\$="[[computeCustomButtonAriaInvalid(customButtonAriaInvalid, value)]]">

                  <!-- Label/placeholder/default empty option -->
                  <option value=""
                      aria-label=""
                      aria-hidden="true"
                      selected\$="[[computeInitialOptionSelected()]]"
                      disabled
                      hidden>
                      {{ label }}{{ placeholder }}
                  </option>

                  <template is="dom-repeat" items="[[options]]" as="option">
                      <option value="[[option.key]]" part="[[option.part]]" selected\$="[[computeSelectedOptionAttribute(option.key, value)]]" disabled\$="[[computeNativeOptionDisabledAttribute(option.key, disabledValues)]]">
                          [[option.value]]
                      </option>
                  </template>
              </select>
              <i class="di di-norgie-opened"
                  aria-hidden="true">
              </i>
          </div>
      </div>

      <!-- Custom dropdown -->
      <div class="custom-dropdown-container"
          on-keydown="handleCustomDropdownKeyDown"
          hidden\$="[[computeUseNativeOptionsMenu()]]"
          on-focusout="autoCloseCustomDropdown">

          <!-- Clickable element -->
          <button id="custom-dropdown-button"
                  aria-haspopup="listbox"
                  data-dropdown-id\$="[[dropdownId]]"
                  class\$="trigger-button [[computeOpenedClass()]] [[computeItemSelectedClass(value)]] [[computeInvalidClass(invalid)]] [[computeDisabledClass(disabled)]]"
                  on-click="toggleCustomOptionsListVisibility"
                  on-focusout="autoCloseCustomDropdown"
                  disabled\$="{{disabled}}"
                  aria-controls="expandable-content"
                  aria-expanded="[[opened]]"
                  aria-required\$="{{requiredField}}"
                  aria-label\$="[[computeAriaLabel(customAriaLabel, label, placeholder, selectedOptionLabel)]]"
                  aria-describedby\$="[[computeCustomButtonErrorAriaDescribedby(customButtonErrorAriaDescribedby)]]"
                  aria-invalid\$="[[computeCustomButtonAriaInvalid(customButtonAriaInvalid, value)]]">

              <!-- Floating label -->
              <div class\$="label [[computeLabelVisibility(value)]]">{{ label }}</div>

              <!-- Select text and icon -->
              <div class\$="button-text-container [[computeHasImageClass(guestAvatar)]]">
                  <template is="dom-if" if="[[guestList]]">
                      <template is="dom-if" if="[[!guestAvatar]]">
                          [[buttonText]]
                      </template>
                      <template is="dom-if" if="[[!isEqualTo(buttonText, guestListSelectOptionLabel)]]">
                          <template is="dom-if" if="[[!isEqualTo(guestAvatar, 'default')]]">
                              <img class\$="guest-avatar [[computeAvatarRoundedClass(avatarRounded)]]" src="[[guestAvatar]]" />
                          </template>
                          <div class="guestlist-buttontext">
                              [[buttonText]]
                              <span class="age-label">[[ageLabel]]</span>
                          <div>
                      </template>

                      <template is="dom-if" if="[[isEqualTo(buttonText, guestListSelectOptionLabel)]]">
                          <span class="selected-icon di di-friends-family"></span>
                          <div class="guestlist-buttontext">
                              [[buttonText]]
                          <div>
                      </template>

                  </template>

                  <template is="dom-if" if="[[!guestList]]">
                      [[buttonText]]
                  </template>

                  <i class="di di-norgie-opened"
                      aria-hidden="true">
                  </i>
              </div>
          </button>

          <!-- Options list -->
          <ul id="custom-dropdown-options-list"
              data-parent-dropdown-id\$="[[dropdownId]]"
              on-focusout="autoCloseCustomDropdown"
              class="options-list hidden"
              role="listbox"
              aria-label\$="[[computeAriaLabel(customAriaLabel, label, placeholder)]]"
              aria-activedescendant\$="option-[[value]]"
              tabindex="-1"
              hidden\$="[[!opened]]">
              <template is="dom-repeat" items="[[options]]" as="option">
                  <li class\$="option-item [[computeSelectedClass(option.key, value)]] [[computeHasImageClass(option.img)]] [[computeOptionDisabledClass(option.key, disabledValues)]]"
                      id\$="option-[[option.key]]"
                      role="option"
                      aria-selected\$="[[computeSelectedOptionAttribute(option.key, value)]]"
                      data-parent-dropdown-id\$="[[dropdownId]]"
                      on-mousedown="selectCustomOption"
                      on-focus="updateFocusedIndex"
                      on-focusout="autoCloseCustomDropdown"
                      on-keydown="handleOptionItemKeyDown"
                      aria-label\$="[[option.value]]"
                      part="[[option.part]]"
                      tabindex="0">
                      <template is="dom-if" if="[[option.img]]">
                          <template is="dom-if" if="[[!isEqualTo(option.img, 'default')]]">
                              <img class\$="[[computeAvatarRoundedClass(avatarRounded)]]" src="[[option.img]]" />
                          </template>
                      </template>
                      <div class="option-value">
                          <template is="dom-if" if="[[isEqualTo(option.value, guestListSelectOptionLabel)]]">
                              <span class="selected-icon di di-friends-family"></span>
                          </template>
                          <div class="option-value-inner">
                              [[option.value]]
                              <template is="dom-if" if="[[option.age]]">
                                  <span class="age-label">[[option.age]]</span>
                              </template>
                          </div>
                      </div>
                  </li>
              </template>
              <template is="dom-if" if="[[guestListAddUrl]]">
                  <li class\$="option-item [[computeSelectedClass(option.key, value)]] add-guest"
                      role="menuitem"
                      tabindex="0"
                      data-parent-dropdown-id\$="[[dropdownId]]"
                      on-mousedown="selectCustomOption"
                      on-focus="updateFocusedIndex"
                      on-focusout="autoCloseCustomDropdown"
                      on-keydown="handleOptionItemKeyDown">
                      <template is="dom-repeat" items="[[guestAddLabel]]" as="guestAdd">
                          <a href="[[guestListAddUrl]]" >
                              <span class\$="add-guest-icon di [[guestAdd.iconClass]]"></span>
                              <span class="option-value">
                                  [[guestAdd.label]]
                              </span>
                          </a>
                      </template>
                  </li>
              </template>
          </ul>
      </div>

      <!-- Hidden span with the custom error aria-describedby for a11y -->
      <span id="single-select-aria-description" hidden>[[computeCustomErrorAriaLabel(invalid, customErrorAriaLabel)]]</span>
   `;
  }

  static get properties() {
    return {
      guestList: {
        type: Boolean,
        value: false
      },
      guestListAddUrl: {
        type: String,
        value: null
      },
      disabledValues: {
        type: Object,
        value: () => []
      },
      nativeDropdown: {
        type: Object,
        value: () => { return {} }
      },
      customDropdownButton: {
        type: Object,
        value: () => { return {} }
      },
      customDropdownOptionsList: {
        type: Object,
        value: () => { return {} }
      },
      guestAvatar: {
        type: String,
        value: ''
      },
      avatarRounded: {
        type: Boolean,
        value: false
      },
      ageLabel: {
        type: String,
        value: ''
      },
      selectedOptionLabel: {
        type: String,
        value: null
      },
      opened: {
        type: Boolean,
        value: false
      },
      value: {
        type: String,
        value: null,
        reflectToAttribute: true,
        notify: true,
        observer: 'updateLabelsAndValue'
      },
      options: {
        type: Object,
        value: () => [],
        observer: 'configureOptions'
      },
      focusedOptionIndex: {
        type: Number,
        value: -1
      },
      searchValue: {
        type: String,
        value: ''
      },
      focusedOption: {
        type: Number,
        value: -1
      },
      buttonText: {
        type: String,
        value: null
      },
      label: {
        type: String,
        value: null,
        reflectToAttribute: true
      },
      placeholder: {
        type: String,
        value: null,
        reflectToAttribute: true
      },
      invalid: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      disabled: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      requiredField: {
        type: String,
        value: 'false'
      },
      forceCustomOptionsMenu: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      dropdownId: {
        type: String,
        computed: 'generateRandomId()'
      },
      guestListSelectOptionLabel: {
        type: String,
        value: 'Select'
      },
      addGuestSelectOption: {
        type: Boolean,
        value: false
      },
      guestAddLabel: {
        type: Object,
        value: () => {
          return [{
            iconClass: 'di-add-button',
            label: 'Add Guest'
          }];
        },
      },
      initialized: {
        type: Boolean,
        value: false
      },
      customAriaLabel: {
        type: String,
        value: ''
      },
      customErrorAriaLabel: {
        type: String,
        value: ''
      },
      customButtonErrorAriaDescribedby: {
        type: String,
        value: ''
      },
      customButtonAriaInvalid: {
        type: Boolean,
        value: false
      },
    };
  }

  ready() {
    super.ready();
    this.nativeDropdown = this.shadowRoot.getElementById('native-dropdown');
    this.customDropdownButton = this.shadowRoot.getElementById('custom-dropdown-button');
    this.customDropdownOptionsList = this.shadowRoot.getElementById('custom-dropdown-options-list');
  }

  connectedCallback() {
    super.connectedCallback();
    setTimeout(() => {
      this.configureOptions();
    });
  }

  configureOptions() {
    this.normalizeOptions();
    this.setInitialFocusedOptionIndex();
    this.updateLabelsAndValue();
    this.setupGuestListOptions();
    this.normalizeDisabledValues();
  }

  normalizeOptions() {

    this.initialized = false;

    // If the array is not a key/value object collection, (e.g. array of strings/numbers), normalize it to key/value objects
    if (this.options && this.options.length && typeof this.options[0] !== 'object') {
      const newArray = [];
      for (let i = 0; i < this.options.length; i++) {
        newArray.push({
          key: String(i), // The option's key will be its index
          value: this.options[i]
        });
      }
      this.options = newArray;
    }

    this.initialized = true;
  }

  setInitialFocusedOptionIndex() {
    if (!this.isNull(this.value)) {
      this.focusedOptionIndex = this.getOptionIndex(this.value);
    }
  }

  setupGuestListOptions() {
    if (this.guestList && this.options.length !== 0 && this.addGuestSelectOption) {
      if (this.options[0].value !== this.guestListSelectOptionLabel) {
        const updatedGuestOption = [];

        updatedGuestOption.unshift({
          key: '0',
          value: this.guestListSelectOptionLabel,
          img: 'default',
          age: ''
        });

        for (let i = 0; i < this.options.length; i++) {
          updatedGuestOption.push({
            key: String(i + 1),
            value: this.options[i].value,
            img: this.options[i].img,
            age: this.options[i].age
          });
        }

        this.options = updatedGuestOption;
        this.guestAvatar = !this.isNull(this.value) ? this.options[this.value].img : '';
      }
    }
  }

  normalizeDisabledValues() {
    if (typeof this.disabledValues !== 'object') {
      const newDisabledValues = [this.disabledValues];
      this.disabledValues = newDisabledValues;
    }
  }

  updateLabelsAndValue() {
    if (this.initialized && !this.isNull(this.value)) {

      // Native dropdown
      this.nativeDropdown.value = this.value;

      // Custom dropdown
      const selectedOptionIndex = this.getOptionIndex(this.value);
      const selectedOptionValue = this.options[selectedOptionIndex] && this.options[selectedOptionIndex].value;
      const selectedOptionLabel = typeof selectedOptionValue !== 'undefined' ? String(selectedOptionValue) : '';

      if (this.guestList && this.options.length !== 0) {
        this.guestAvatar = !this.isNull(selectedOptionIndex) && selectedOptionIndex !== -1 ? this.options[selectedOptionIndex].img : this.options[0].img;
        this.ageLabel = !this.isNull(selectedOptionIndex) && selectedOptionIndex !== -1 ? this.options[selectedOptionIndex].age : this.options[0].age;
      }

      this.buttonText = this.selectedOptionImageLabel || selectedOptionLabel || this.label || this.placeholder || '';
      this.selectedOptionLabel = selectedOptionLabel;
    } else {
      this.buttonText = this.label || this.placeholder || '';
      this.nativeDropdown.value = '';
    }
  }

  toggleCustomOptionsListVisibility(event) {
    event.stopPropagation();
    this.opened = !this.opened;
    if (this.opened) {
      this._showDropdown();
    } else {
      this._hideDropdown();
    }
    // Set the focused option index to the selected option to start the arrow keys navigation from there when the dropdown is opened
    if (this.opened) {
      const selectedOptionIndex = this.getOptionIndex(this.value);
      this.focusedOptionIndex = selectedOptionIndex > -1 ? selectedOptionIndex : -1;
      if (this.focusedOptionIndex > -1) {
        this.customDropdownOptionsList.querySelectorAll('li')[this.focusedOptionIndex].focus();
      }
      if (selectedOptionIndex <= -1) {
        this.customDropdownOptionsList.querySelectorAll('li')[0].focus();
      }
    }
  }

  _showDropdown() {
    const dropdownMenu = this.customDropdownOptionsList;
    dropdownMenu.classList.remove('hidden');
  }

  _hideDropdown() {
    const dropdownMenu = this.customDropdownOptionsList;
    dropdownMenu.classList.add('hidden');
  }

  handleChange(newSelectedOptionKey) {
    const previousSelectedKey = this.value;

    // Update the general new value
    this.value = newSelectedOptionKey;

    // Update value for custom dropdown
    const selectedOptionIndex = this.getOptionIndex(newSelectedOptionKey);
    this.selectedOptionLabel = selectedOptionIndex > -1 ? this.options[selectedOptionIndex].value : '';

    // Update value for native dropdown
    this.nativeDropdown.value = newSelectedOptionKey;

    if (previousSelectedKey !== newSelectedOptionKey) {
      this.emitNewValueEvent();
    }
  }

  handleChangeIfNotOpened(newSelectedOptionIndex) {
    if (!this.opened) {
      this.opened = !this.opened;
      this._showDropdown();
    }
    const selectedOptionKey = this.options[newSelectedOptionIndex].key;
    this.handleChange(selectedOptionKey);
    this.customDropdownOptionsList.querySelectorAll('li')[newSelectedOptionIndex].focus();
  }

  selectNativeOption() {
    const selectedOptionKey = this.nativeDropdown.value;
    const selectedOptionIndex = this.getOptionIndex(selectedOptionKey);
    this.focusedOptionIndex = selectedOptionIndex;
    this.handleChange(selectedOptionKey);
    this.opened = false;
    this._hideDropdown();
  }

  selectCustomOption(event) {
    event.preventDefault();
    const selectedOptionIndex = !this.isNull(event.model) ? event.model.index : null;
    if (selectedOptionIndex !== null && this.disabledValues.indexOf(selectedOptionIndex) < 0) {
      this.focusedOptionIndex = selectedOptionIndex;
      const selectedOptionKey = this.options[selectedOptionIndex].key;
      this.handleChange(selectedOptionKey);
      this.opened = false;
      this._hideDropdown();

      setTimeout(() => {
        this.customDropdownButton.focus();
      });
    }
  }

  autoCloseCustomDropdown(event) {
    const target = event.relatedTarget || document.activeElement;
    const parentId = target.getAttribute('data-parent-dropdown-id');
    const dropdownId = target.getAttribute('data-dropdown-id');

    if (dropdownId !== this.dropdownId && parentId !== this.dropdownId) {
      this.opened = false;
      this._hideDropdown();
    }
  }

  reset() {
    this.selectedOptionLabel = '';
    this.value = null;
    this.focusedOptionIndex = -1;
    this.buttonText = this.label || this.placeholder || '';

    this.emitNewValueEvent();
  }

  computeItemSelectedClass(value) {
    return this.isNull(value) ? '' : 'item-selected';
  }

  computeOpenedClass(opened) {
    return opened ? 'opened' : '';
  }

  computeSelectedClass(optionKey, value) {
    return optionKey === value ? 'selected' : '';
  }

  computeLabelVisibility(value) {
    return this.isNull(value) ? 'invisible' : '';
  }

  computeInvalidClass(invalid) {
    return invalid ? 'invalid' : '';
  }

  computeDisabledClass(disabled) {
    return disabled ? 'disabled' : '';
  }

  computeInitialOptionSelected() {
    return this.isNull(this.value);
  }

  computeSelectedOptionAttribute(optionKey, value) {
    return optionKey === value;
  }

  computeUseNativeOptionsMenu() {
    if (this.forceCustomOptionsMenu) {
      return false;
    } else {
      return isTouchDevice();
    }

    function isTouchDevice() {
      const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
      const mq = function (query) {
        return window.matchMedia(query).matches;
      };

      if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
        return true;
      }

      // include the 'heartz' as a way to have a non matching MQ to help terminate the join
      // https://git.io/vznFH
      const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
      return mq(query);
    }
  }

  handleCustomDropdownKeyDown(event) {
    let itemIndexToSelect;
    switch (event.key.toLowerCase()) {
      case 'arrowup':
      case 'up': // IE Compatibility
        event.preventDefault();
        itemIndexToSelect = this.focusedOptionIndex - 1;
        if (this.disabledValues.indexOf(itemIndexToSelect) >= 0) {
          itemIndexToSelect--;
        }

        if (itemIndexToSelect >= 0 && itemIndexToSelect < this.options.length) {
          if (this.disabledValues.indexOf(itemIndexToSelect) >= 0) {
            itemIndexToSelect--;
          }
          this.focusedOptionIndex = itemIndexToSelect;
          this.handleChangeIfNotOpened(itemIndexToSelect);

        }

        break;
      case 'arrowdown':
      case 'down':  // IE Compatibility
        event.preventDefault();
        const selectedOptionIndex = this.getOptionIndex(this.value);
        if (selectedOptionIndex >= 0) {
          itemIndexToSelect = selectedOptionIndex + 1;
        } else {
          itemIndexToSelect = 0;
        }
        if (this.disabledValues.indexOf(itemIndexToSelect) >= 0) {
          itemIndexToSelect++;
        }
        if (itemIndexToSelect < this.options.length) {
          if (this.disabledValues.indexOf(itemIndexToSelect) >= 0) {
            itemIndexToSelect++;
          }
          this.focusedOptionIndex = itemIndexToSelect;
          this.handleChangeIfNotOpened(itemIndexToSelect);
        }

        break;
      case 'escape':
      case 'esc': // IE Compatibility
        event.preventDefault();
        this.autoCloseCustomDropdown(event);
        this.customDropdownButton.focus();
        break;
      case 'home':
        event.preventDefault();
        if (this.opened) {
          itemIndexToSelect = 0;
          this.focusedOptionIndex = itemIndexToSelect;
          this.customDropdownOptionsList.scrollTop = 0;
          const selectedOptionKey = this.options[itemIndexToSelect].key;
          this.handleChange(selectedOptionKey);
          this.customDropdownOptionsList.querySelectorAll('li')[0].focus();
        }
        break;
      case 'end':
        event.preventDefault();
        if (this.opened) {
          itemIndexToSelect = this.options.length - 1;
          this.focusedOptionIndex = itemIndexToSelect;
          this.customDropdownOptionsList.scrollTop = this.customDropdownOptionsList.offsetHeight;
          const selectedOptionKey = this.options[itemIndexToSelect].key;
          this.handleChange(selectedOptionKey);
          this.customDropdownOptionsList.querySelectorAll('li')[this.options.length - 1].focus();
        };
        break;
      case 'tab':
        itemIndexToSelect = this.focusedOptionIndex;
        if (this.opened && itemIndexToSelect <= this.options.length - 1) {
          this.customDropdownOptionsList.querySelectorAll('li')[itemIndexToSelect].focus();
        } else {
          this.autoCloseCustomDropdown(event);
        }
        break;
      default:
        this._filter(event);
        break;
    }
  }

  _filter(event) {
    let searchText;
    let keycode = event.keyCode;
    if (((48 <= keycode && keycode <= 90) || (keycode >= 96 && keycode <= 106))) {
      if (!this.opened) {
        this.opened = !this.opened;
        this._showDropdown();
      }
      searchText = event.key;
      this.searchValue = this.searchValue + searchText;
      let searchIndex = this._findOptionIndexForStartsWith(this.searchValue);
      if (searchIndex > -1) {
        this.focusedOptionIndex = searchIndex;
        this.customDropdownOptionsList.querySelectorAll('li')[this.focusedOptionIndex].focus();
      };
    }
    setTimeout(() => {
      this.searchValue = '';
    }, 1000)
  }

  _findOptionIndexForStartsWith(key) {
    for (let i = 0; i < this.options.length; i++) {
      if (this.options[i].value.toLowerCase().startsWith(key.toLowerCase()) && !this.options[i].disabled) {
        return i;
      } else if (this.options[i].value.startsWith(key) && !this.options[i].disabled) {
        return i;
      }
    }
    return -1;
  }

  handleOptionItemKeyDown(event) {
    switch (event.key.toLowerCase()) {
      case 'enter':
        event.preventDefault();
        this.selectCustomOption(event);
        break;
      case ' ': // Space bar - do nothing but prevent scrolling the page
      case 'spacebar': // IE Compatibility
        event.preventDefault();
        break;
      default:
        break;
    }
  }



  updateFocusedIndex(event) {
    const newFocusedOptionIndex = event.model.index;
    this.focusedOptionIndex = newFocusedOptionIndex != null ? newFocusedOptionIndex : 0;
  }

  generateRandomId() {
    let result = '';
    const length = 6;
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

    for (let i = length; i > 0; --i) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }

    return result;
  }

  getOptionIndex(optionToSearch) {
    let index = -1;
    for (let i = 0; i < this.options.length; i++) {
      const option = this.options[i];
      if (optionToSearch === option.key || optionToSearch === String(option.key)) {
        index = i;
        break;
      }
    }
    return index;
  }

  emitNewValueEvent() {
    const detail = {
      index: this.getOptionIndex(this.value),
      key: this.value,
      value: this.selectedOptionLabel
    };
    this.dispatchEvent(new CustomEvent('item-selected', { detail: detail }));
  }

  computeHasImageClass(variable) {
    return variable ? 'has-image' : '';
  }

  computeAvatarRoundedClass(variable) {
    return variable ? 'avatar-rounded' : '';
  }

  isNull(variable) {
    return variable === null || variable === '' || typeof variable === 'undefined';
  }

  isEqualTo(title, string) {
    return title === string;
  }

  computeOptionDisabledClass(key, disabledValues) {
    return disabledValues.indexOf(this.getOptionIndex(key)) >= 0 ? 'option-disabled' : '';
  }

  computeNativeOptionDisabledAttribute(key, disabledValues) {
    return disabledValues.indexOf(this.getOptionIndex(key)) >= 0 ? '' : null;
  }

  computeAriaLabel(customAriaLabel, label, placeholder, selectedOptionLabel) {
    if (selectedOptionLabel) {
      return `${customAriaLabel || label || placeholder || ''}`.trim() + `, ${selectedOptionLabel}`.trim();
    } else {
      return `${customAriaLabel || label || placeholder || ''}`.trim();
    }
  }

  computeCustomErrorAriaLabel(invalid, customErrorAriaLabel) {
    return (invalid && customErrorAriaLabel.trim() !== '') ? customErrorAriaLabel : '';
  }

  computeCustomButtonErrorAriaDescribedby(customButtonErrorAriaDescribedby) {
    return (customButtonErrorAriaDescribedby.trim() !== '') ? customButtonErrorAriaDescribedby : 'single-select-aria-description';
  }

  computeCustomButtonAriaInvalid(customButtonAriaInvalid, value) {
    if (customButtonAriaInvalid) {
      return this.isNull(value) ? 'true' : 'false';
    }
  }

  focusDropdown() {
    if (this.computeUseNativeOptionsMenu()) {
      this.nativeDropdown.focus();
    } else {
      this.customDropdownButton.focus();
    }
  }
}

window.customElements.define(WdprSingleSelect.is, WdprSingleSelect);
